module.exports = __webpack_public_path__ + "static/img/btn-bg.288279ec.png";